module.exports = __webpack_public_path__ + "img/IMG_6689_L_Foamcore.51390ef0.jpg";